<div class="ui-g">
  <div class="ui-g-12" style="position: relative" *mobxAutorun>
    <div *ngIf="selectedVersion" class="card card-w-title">
      <h3 *ngIf="termsConditionsVersions.length == 1">
        Please Read and Accept our Terms and Conditions
      </h3>
      <div class="text-warning text-sm" *ngIf="requiredByDate && requiredByDate > now">
        (Required by {{ requiredByDate.toLocaleDateString() }})
      </div>
      <h1>Terms & Conditions</h1>

      <div *ngIf="selectedVersion.documentUrl" class="ui-grid-row" style="margin-top: 20px">
        <div class="ui-grid-col-12">
          <a href="#" (click)="downloadPdf(); $event.preventDefault()">Download PDF</a>
        </div>
      </div>

      <div class="ui-grid-row" style="margin-top: 10px; margin-bottom: 10px">
        <div class="ui-grid-col-12">
          <div style="white-space: pre-line">{{ selectedVersion.text }}</div>
        </div>
      </div>

      <div class="ui-grid-row" style="margin-top: 20px">
        <div class="ui-grid-col-12 ui-sm-12">
          <p-checkbox
            [(ngModel)]="isAgreed"
            name="isAgreed"
            binary="true"
            label="I Agree to these details"
          ></p-checkbox>
        </div>
        <div class="ui-grid-col-12">
          <button
            type="button"
            icon="fa ui-icon-check"
            (click)="agree()"
            class="green-btn"
            style="float: right"
            pButton
            label="Save"
            [disabled]="!isAgreed"
          ></button>
        </div>
      </div>
    </div>
  </div>
</div>
